/*
  SOFS — Barra de disponibilidad por talla.

  La barra está SIEMPRE visible: con stock de sobra se muestra llena, con stock
  bajo (1..data-threshold) proporcional, y agotada vacía con el texto apagado.
  El estado inicial lo pinta el snippet en Liquid; acá sólo se actualiza cuando
  cambia la talla.

  Lee los selectores de opción del formulario de producto para saber qué variante
  está seleccionada, así que no depende del JS del tema y sirve igual en la PDP y
  en el modal de compra rápida (que se inyecta por AJAX).

  Animación: se usa la Web Animations API (`element.animate`) en vez de
  transiciones CSS. Una transición sólo arranca si el navegador alcanzó a
  registrar el estilo anterior — con nodos recién insertados, con `display:none`
  de por medio o con cambios de estilo en la misma tarea, se la salta y el
  cambio queda instantáneo. `animate()` siempre interpola desde el fotograma
  que uno le indica, sin esa condición.
*/
(function () {
  'use strict';

  var MIN_FILL = 8;   // % mínimo para que 1 unidad siga siendo visible

  /* Cortes del semáforo por defecto, en % del umbral (los manda el snippet). */
  var PCT_MID = 60, PCT_LOW = 30;

  var DUR_TEXT = 260; // ms del fundido del texto y de la cantidad

  /* La duración del recorrido se calcula según cuánto tiene que moverse la barra:
     un salto de 100% a 30% con la misma duración que uno de 10% se siente un
     tirón. Así la velocidad es parecida siempre. */
  var DUR_MIN = 1500, DUR_MAX = 3200, DUR_POR_PCT = 16;

  function duracion(desde, hasta) {
    /* Con "reducir movimiento" del sistema NO se corta a un valor fijo: se acorta
       un poco. Antes eran 200ms y la barra se veía saltar — y si el usuario tiene
       esa opción activada en su equipo, ningún ajuste de velocidad se notaba. */
    var factor = sinMovimiento() ? 0.55 : 1;
    var d = DUR_MIN + Math.abs(hasta - desde) * DUR_POR_PCT;
    return Math.round(Math.min(DUR_MAX, Math.max(DUR_MIN, d)) * factor);
  }

  function sinMovimiento() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function puedeAnimar(el) {
    return !!(el && el.animate) && !sinMovimiento();
  }

  function scopeOf(bar) {
    return (
      bar.closest('form[data-product-form]') ||
      bar.closest('form[action*="/cart/add"]') ||
      bar.closest('[data-product-blocks]') ||
      bar.parentElement
    );
  }

  function valueOfWrapper(wrapper) {
    var checked = wrapper.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;

    var hidden = wrapper.querySelector('input[data-popout-input], input[type="hidden"][data-single-option-selector]');
    if (hidden) return hidden.value;

    var select = wrapper.querySelector('select');
    if (select) return select.value;

    return null;
  }

  /* Lee los valores por nombre de opción (respaldo si no hay wrappers posicionados). */
  function readByName(scope) {
    var inputs = scope.querySelectorAll('[data-single-option-selector]');
    var order = [];
    var found = {};

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var m = /^options\[(.*)\]$/.exec(input.getAttribute('name') || '');
      if (!m) continue;
      var name = m[1];
      if (order.indexOf(name) === -1) order.push(name);
      if (input.type === 'radio') {
        if (input.checked) found[name] = input.value;
      } else {
        found[name] = input.value;
      }
    }

    if (!order.length) return null;

    var values = [];
    for (var j = 0; j < order.length; j++) {
      if (found[order[j]] == null) return null;
      values.push(found[order[j]]);
    }
    return values;
  }

  /* Devuelve los valores seleccionados en el orden de las opciones del producto.
     Ojo: el selector de cantidad también lleva [data-selector-wrapper] pero no
     tiene data-option-position — por eso filtramos por ese atributo. */
  function readSelection(scope) {
    if (!scope) return null;

    var wrappers = Array.prototype.slice.call(
      scope.querySelectorAll('[data-selector-wrapper][data-option-position]')
    );
    if (!wrappers.length) return readByName(scope);

    wrappers.sort(function (a, b) {
      return (parseInt(a.getAttribute('data-option-position'), 10) || 0) -
             (parseInt(b.getAttribute('data-option-position'), 10) || 0);
    });

    var values = [];
    for (var i = 0; i < wrappers.length; i++) {
      var v = valueOfWrapper(wrappers[i]);
      if (v === null) return null; // selección incompleta
      values.push(v);
    }
    return values;
  }

  function parseVariants(bar) {
    if (bar._sofsVariants) return bar._sofsVariants;
    try {
      bar._sofsVariants = JSON.parse(bar.getAttribute('data-variants') || '[]');
    } catch (e) {
      bar._sofsVariants = [];
    }
    return bar._sofsVariants;
  }

  function porSelectores(scope, variants) {
    var values = readSelection(scope);
    if (values === null) return null;
    var key = values.join('||');
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].k === key) return variants[i];
    }
    return null;
  }

  function porIdOculto(scope, variants) {
    var input = scope.querySelector('input[name="id"]');
    var id = input ? parseInt(input.value, 10) : NaN;
    if (!id) return null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].i === id) return variants[i];
    }
    return null;
  }

  /*
    Dos fuentes y se contradicen a propósito de nada:
      · los radios se marcan en el mismo clic → sirven para reaccionar ya
      · el input oculto name="id" lo confirma el tema ~200ms después → es la verdad

    Durante el re-render del tema una queda desactualizada y el estado hacía
    ping-pong. Por eso la pasada inmediata usa los radios y la pasada de
    asentamiento le da la última palabra al input.
  */
  function findMatch(bar, variants, preferirRadios) {
    var scope = scopeOf(bar);
    if (!scope) return null;

    if (preferirRadios) {
      return porSelectores(scope, variants) || porIdOculto(scope, variants);
    }
    return porIdOculto(scope, variants) || porSelectores(scope, variants);
  }

  /* --- animación ------------------------------------------------------------ */

  /* Ancho real que se está viendo ahora mismo, en % de la pista. Es lo que hay que
     usar como punto de partida: si la talla cambia mientras la barra todavía se
     está moviendo, el último valor pedido no es el que está en pantalla. */
  function pctActual(bar, fill) {
    var pista = bar.querySelector('.sofs-stock__track');
    var ancho = pista ? pista.getBoundingClientRect().width : 0;
    if (!ancho) return typeof bar._sofsPct === 'number' ? bar._sofsPct : 0;
    return (fill.getBoundingClientRect().width / ancho) * 100;
  }

  /*
    El recorrido lo hace una transición CSS, no element.animate(). Con animate()
    se veía un salto por dos motivos:
      · el estilo base se ponía en el valor final antes de que la animación
        arrancara (un fotograma con la barra ya en su destino), y
      · al interrumpir un movimiento, el fotograma inicial era el último valor
        pedido y no el que estaba en pantalla.
    La transición interpola siempre desde el valor real y se encadena sola si
    llega otro cambio a mitad de camino. Se puede usar porque la barra ahora está
    SIEMPRE visible: el motivo original para no usarla (nodos recién insertados o
    con display:none, donde el navegador se la salta) ya no aplica.
  */
  function mover(bar, fill, pct) {
    var desde = pctActual(bar, fill);
    bar._sofsPct = pct;

    if (Math.abs(desde - pct) < 0.5) { fill.style.width = pct + '%'; return; }

    fill.style.transitionDuration = duracion(desde, pct) + 'ms';
    fill.style.width = pct + '%';
  }

  function fundirTexto(el) {
    if (!puedeAnimar(el)) return;
    var hasta = getComputedStyle(el).opacity || 1;
    el.animate([{ opacity: 0 }, { opacity: hasta }], { duration: DUR_TEXT, easing: 'ease-out' });
  }

  /* Nivel del semáforo según lo que queda respecto al umbral. Pinta barra, punto
     y texto (todos cuelgan de --sofs-stock-color / currentColor). */
  function nivelDe(bar, mode, qty, threshold) {
    if (mode === 'out') return 'out';
    if (mode === 'full') return 'alto';
    var mid = parseFloat(bar.getAttribute('data-pct-mid'));
    var low = parseFloat(bar.getAttribute('data-pct-low'));
    if (isNaN(mid)) mid = PCT_MID;
    if (isNaN(low)) low = PCT_LOW;
    var ratio = threshold > 0 ? (qty * 100) / threshold : 100;
    if (ratio >= mid) return 'alto';
    if (ratio >= low) return 'medio';
    return 'bajo';
  }

  /* Texto de la cantidad ("3 unidades"), sólo en modo low. */
  function textoCantidad(bar, qty) {
    if (qty === 1) return bar.getAttribute('data-qty-text-one') || '';
    var plantilla = bar.getAttribute('data-qty-text') || '';
    return plantilla.replace('[n]', qty);
  }

  /* --- estado --------------------------------------------------------------- */

  /*
    Tres estados, todos visibles:
      out  → talla agotada: "Agotado", color apagado, barra vacía
      low  → quedan entre 1 y el umbral: "Disponible", barra proporcional
      full → queda más que el umbral (o venta sin control de stock): barra llena

    Y sobre el estado, el nivel del semáforo (alto / medio / bajo), que sólo cambia
    el color.
  */
  function render(bar, match, threshold) {
    var qty = match.q;
    var mode = match.a === false ? 'out'
             : (qty >= 1 && qty <= threshold ? 'low' : 'full');

    var state = mode + ':' + qty + '/' + threshold;
    if (bar._sofsState === state) return;
    var antes = bar._sofsState;
    bar._sofsState = state;

    var esOut = mode === 'out';
    var eraOut = typeof antes === 'string' && antes.indexOf('out:') === 0;
    var texto = bar.getAttribute(esOut ? 'data-text-out' : 'data-text-in');
    var label = bar.querySelector('.sofs-stock__label');
    if (label && texto && label.textContent !== texto) {
      label.textContent = texto;
    }
    if (label && esOut !== eraOut && antes) fundirTexto(label);

    /* La cantidad sólo se muestra cuando queda poco (modo low). */
    var qtyEl = bar.querySelector('.sofs-stock__qty');
    if (qtyEl) {
      var nuevoQty = mode === 'low' ? textoCantidad(bar, qty) : '';
      if (qtyEl.textContent !== nuevoQty) {
        qtyEl.textContent = nuevoQty;
        if (nuevoQty && antes) fundirTexto(qtyEl);
      }
    }

    bar.classList.toggle('sofs-stock--out', esOut);

    var nivel = nivelDe(bar, mode, qty, threshold);
    bar.classList.toggle('sofs-stock--medio', nivel === 'medio');
    bar.classList.toggle('sofs-stock--bajo', nivel === 'bajo');

    var fill = bar.querySelector('.sofs-stock__fill');
    if (fill) {
      mover(bar, fill, esOut ? 0 : (mode === 'full' ? 100 : Math.max(MIN_FILL, Math.round((qty / threshold) * 100))));
    }
  }

  function update(bar, preferirRadios) {
    var variants = parseVariants(bar);
    if (!variants.length) return;

    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 10;
    var match = variants.length === 1 ? variants[0] : findMatch(bar, variants, preferirRadios);

    /* Sin variante resoluble (re-render a medias): conservar lo que ya se ve.
       El reintento diferido corrige el estado cuando el tema termina. */
    if (!match) return;

    render(bar, match, threshold);
  }

  function init(bar) {
    if (bar._sofsInit) return;
    bar._sofsInit = true;

    /* El snippet ya pintó el estado de la variante inicial. Se adopta como punto
       de partida para no re-animar la barra al cargar la página. */
    bar._sofsState = bar.getAttribute('data-init-state') || null;
    var pct0 = parseFloat(bar.getAttribute('data-init-pct'));
    bar._sofsPct = isNaN(pct0) ? 0 : pct0;

    var scope = scopeOf(bar);
    if (!scope) return;

    /* Pasada inmediata con los radios (reacción al toque) y pasadas de
       asentamiento donde manda el input oculto, ya confirmado por el tema.

       Ojo: las pasadas NO se reinician con cada evento. Antes sí, y como el tema
       muta el DOM durante ~medio segundo después del clic, cada mutación corría
       los reintentos hacia adelante y la barra recién arrancaba ~800ms después
       — se sentía como si diera un salto tardío. Ahora la ronda se programa una
       vez desde el primer evento; si el tema sigue moviendo cosas, el observer
       arranca otra ronda cuando esta termina. */
    var queued = false;
    var rapidas = false;   // ronda rápida en curso
    var finales = [];      // pasadas finales (se reinician con cada evento)

    var schedule = function () {
      /* Rápidas: NO se reinician, así el primer movimiento arranca a los ~120ms
         aunque el tema siga mutando el DOM. */
      if (!rapidas) {
        rapidas = true;
        [120, 320].forEach(function (ms, i, todas) {
          setTimeout(function () {
            update(bar, false);
            if (i === todas.length - 1) rapidas = false;
          }, ms);
        });
      }

      /* Finales: SÍ se reinician, para que siempre haya una lectura después de la
         última mutación del tema. Sin esto la barra se podía quedar congelada en
         un valor intermedio al cambiar de talla a mitad del recorrido: las pasadas
         de la ronda anterior leían el estado viejo y las nuevas no se programaban. */
      finales.forEach(clearTimeout);
      finales = [520, 1100].map(function (ms) {
        return setTimeout(function () { update(bar, false); }, ms);
      });

      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        update(bar, true);
      });
    };

    ['change', 'input', 'click'].forEach(function (evt) {
      scope.addEventListener(evt, schedule, true);
    });

    /* Red de seguridad: el tema puede reescribir los selectores (popout, swatches,
       re-render de sección) sin disparar eventos que burbujeen hasta acá. */
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var t = records[i].target;
          var el = t.nodeType === 1 ? t : t.parentElement;
          if (el && el.closest('.sofs-stock')) continue; // ignorar nuestros propios cambios
          schedule();
          return;
        }
      }).observe(scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['checked', 'value', 'aria-current', 'class'] });
    }

    update(bar, false);
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll('[data-sofs-stock]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  function boot() {
    scan(document);

    /* La compra rápida inyecta la sección por AJAX después de cargar la página. */
    if (window.MutationObserver) {
      new MutationObserver(function () { scan(document); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
